var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18h8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20v1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3v1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20v1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10v-7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3v18"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8v8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12h13"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6h-1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6h-13"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12h1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18h1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18h1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14v2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.a5036be7b6d1a649c027c7deda775fdb.svg";
export { ForwardRef as ReactComponent };